import { NgModule } from '@angular/core';

import { MgEscapedHtmlPipe } from './MgEscapedHtml.pipe';

@NgModule({
  declarations: [MgEscapedHtmlPipe],
  exports: [MgEscapedHtmlPipe],
})
export class MgEscapedHtmlModule {}
